import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SUPABASE_URL, supabaseHeaders } from '../supabase';

const POKEAPI = 'https://pokeapi.co/api/v2';

const GENS = [
  { label: 'Gen 1', min: 1,   max: 151  },
  { label: 'Gen 2', min: 152, max: 251  },
  { label: 'Gen 3', min: 252, max: 386  },
  { label: 'Gen 4', min: 387, max: 493  },
  { label: 'Gen 5', min: 494, max: 649  },
  { label: 'Gen 6', min: 650, max: 721  },
  { label: 'Gen 7', min: 722, max: 809  },
  { label: 'Gen 8', min: 810, max: 905  },
  { label: 'Gen 9', min: 906, max: 1025 },
];

let cachedPokeList = null;

function idFromUrl(url) {
  return parseInt(url.replace(/\/$/, '').split('/').pop(), 10);
}

function ShinyDex() {
  const navigate = useNavigate();
  const [pokeList, setPokeList] = useState([]);
  const [ownedIds, setOwnedIds] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [selectedGen, setSelectedGen] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      let list = cachedPokeList;
      if (!list) {
        const res = await fetch(`${POKEAPI}/pokemon?limit=100000&offset=0`);
        const data = await res.json();
        list = data.results || [];
        cachedPokeList = list;
      }
      setPokeList(list);

      const res = await fetch(`${SUPABASE_URL}/rest/v1/shinies?select=pokemon_id`, {
        headers: supabaseHeaders(false),
      });
      const shinies = await res.json();
      const ids = new Set((Array.isArray(shinies) ? shinies : []).map(s => s.pokemon_id));
      setOwnedIds(ids);
      setLoading(false);
    };
    fetchData();
  }, []);

  const baseList = pokeList.filter(p => {
    const pid = idFromUrl(p.url);
    return (
      pid <= 1025 &&
      !p.name.includes('-mega') &&
      !p.name.includes('-gmax') &&
      !p.name.includes('koraidon') &&
      !p.name.includes('miraidon')
    );
  });

  const filteredList = selectedGen
    ? baseList.filter(p => {
        const pid = idFromUrl(p.url);
        return pid >= selectedGen.min && pid <= selectedGen.max;
      })
    : baseList;

  return (
    <div className="app-container">
      <div className="header">
        <div className="header-title-row">
          <h1>Shiny Dex</h1>
          {!loading && (
            <span className="shinydex-counter">{ownedIds.size}/{baseList.length}</span>
          )}
        </div>
        <div className="controls">
          <button onClick={() => navigate('/pokemon/shinies')} className="header-nav-btn">←</button>
        </div>
      </div>

      <div className="shinydex-gen-filters">
        <button
          className={`shinydex-gen-btn${!selectedGen ? ' shinydex-gen-btn--active' : ''}`}
          onClick={() => setSelectedGen(null)}
        >
          All
        </button>
        {GENS.map(gen => (
          <button
            key={gen.label}
            className={`shinydex-gen-btn${selectedGen === gen ? ' shinydex-gen-btn--active' : ''}`}
            onClick={() => setSelectedGen(selectedGen === gen ? null : gen)}
          >
            {gen.label}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="no-results">Loading...</p>
      ) : (
        <div className="shinydex-list">
          {filteredList.map((p) => {
            const pid = idFromUrl(p.url);
            const owned = ownedIds.has(pid);
            const sprite = owned
              ? `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/shiny/${pid}.png`
              : `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${pid}.png`;

            return (
              <div key={p.name} className={`shinydex-row${owned ? ' shinydex-row--owned' : ''}`}>
                <img src={sprite} alt={p.name} className="shinydex-img" />
                <span className="shinydex-name">{p.name}</span>
                <span className="shinydex-num">#{String(pid).padStart(4, '0')}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default ShinyDex;
